import { useUserIsAbroad } from 'app/hooks/useUserIsAbroad';
import React from 'react';

type UserContextType = {
    isAbroad: boolean;
};

export const UserContext = React.createContext<UserContextType>({
    isAbroad: false,
});

export const UserContextProvider: React.FC<unknown> = ({ children }): React.ReactElement => {
    const isAbroad = useUserIsAbroad();

    // eslint-disable-next-line react/jsx-no-constructed-context-values
    return <UserContext.Provider value={{ isAbroad }}>{children}</UserContext.Provider>;
};
